/**
 * 《南洋行》第 3 节《大海龟旅店》— 原文引文（唯一来源：story.txt）。
 * 所有带引号的对白必须逐字保留；笔误按 docs/STORY_ADAPTATION.md 规范化（江子城→江子潮，不详→不祥，用有→用）。
 * 本文件是对白数据与单元测试共同的事实来源。
 */

/** 逐字引用的原文对白（引号内内容）。 */
export const INN_QUOTES = {
  wu1: '哈哈，这是一张完整的龟壳？哈哈，有这么大的海龟嘛！罗大湖啊，你当我没见过中原鲁师傅的木工？这就是木头的，漆的像龟壳罢了！',
  luo1: '告诉你吴庸，这是真的。这里的老板有天跟我喝酒，喝多了无意中说出来的。',
  wu2: '哦？他说大话出了名的！再说，他满口夹杂不清的中原话，你又喝多了，能确定嘛！',
  luo2a: '我那天确实喝多了，',
  luo2b: '可是，我确定我没有听错。因为他说的不是一句话，而是在讲述他的亲身经历。',
  wu3a: '亲身经历？',
  wu3b: '我亲身经历了落入海洋深处三天，却没有淹死！你相信吗？',
  heckle1: '喝多了，洗洗睡吧！',
  heckle2: '我泡在酒缸里三十天都没事！',
  heckle3: '我在沙漠里睡了三个月！',
  wu4: '你看到了？！',
} as const;

/** 原文叙述句（逐字；仅规范化记录在案的笔误）。 */
export const INN_NARRATION = {
  roof: '屋顶俨然就像一个巨大的龟壳，没有围墙，只用几根柱子支撑起来。',
  turtles: '看起来像门口的地方摆着两只小海龟。',
  weatherFolk: '这里的人大多数了解这里的气候，眼看不会下多大的雨，年轻一点的就满不在乎的继续做自己的事，女孩子们和年长一些的有些站在大海龟旅店门口，有些则进去趁机喝一杯。',
  crowded: '店里人很多。',
  squeezeIn: '赵呈博和江子潮好不容易挤了进去，找了个位置坐下。',
  bitterWine: '要了一杯苦苦的酒，江子潮一边喝，一边看着形形色色的人们。',
  mezzanine: '屋顶中央部分用一层木地板隔开，靠近酒台的地方有一个简陋的木板楼梯架了上去。',
  upstairs: '楼上应该就是住宿的房间了。',
  argueStart: '跟江子潮一张桌子上的两个男人突然争吵起来：',
  wuLook: '看起来凶悍点的人不屑的说。他嗓门比较大，胡渣很乱，眼睛有神。',
  luoLook: '名叫罗大湖的华服年轻人涨得通红。他看起来年纪和江子潮相仿，但显然家产颇丰，身上的穿戴都显得很显档次。',
  wuDisbelief: '吴庸完全不相信。',
  luoSaid: '罗大湖说，',
  wuStands: '吴庸摇了摇头，晃晃着站起来，大声说道：',
  crowdLaugh: '众人大笑。有人纷纷说道：',
  chaos: '一时间场面混乱无比。',
  wuTurns: '吴庸转过头，看着罗大湖，努努嘴：',
  luoDim: '罗大湖本来发亮的眼睛暗了下来。他不说话，低下头，继续喝酒。',
  omen1: '江子潮准备看事情怎么发展呢，见到居然这样停止了，',
  omen2: '忽然间江子潮有一种不祥的预感。他突然感到一种发自心里的不安，从后背慢慢爬上前额。',
  omen3: '他扭头朝赵呈博看去，只见赵呈博眉头紧缩，盯着罗大湖，似乎在思索什么。',
} as const;

/**
 * 与 story.txt 原文逐字比对时需要先应用的笔误规范化（见 STORY_ADAPTATION.md）。
 * 测试用：把原文规范化后再检查引文是否为子串。
 */
export function normaliseStoryText(raw: string): string {
  return raw
    .replace(/江子城/g, '江子潮')
    .replace(/不详的预感/g, '不祥的预感')
    .replace(/屋顶中央部分用有一层木地板隔开/g, '屋顶中央部分用一层木地板隔开');
}

/** 便于测试：按剧情顺序列出全部“必须保留”的引文与叙述。 */
export const INN_MANDATORY_IN_ORDER: readonly string[] = [
  INN_NARRATION.roof,
  INN_NARRATION.turtles,
  INN_NARRATION.crowded,
  INN_NARRATION.bitterWine,
  INN_NARRATION.mezzanine,
  INN_NARRATION.upstairs,
  INN_NARRATION.argueStart,
  INN_QUOTES.wu1,
  INN_QUOTES.luo1,
  INN_QUOTES.wu2,
  INN_QUOTES.luo2a,
  INN_QUOTES.luo2b,
  INN_QUOTES.wu3a,
  INN_QUOTES.wu3b,
  INN_QUOTES.heckle1,
  INN_QUOTES.heckle2,
  INN_QUOTES.heckle3,
  INN_QUOTES.wu4,
  INN_NARRATION.luoDim,
  INN_NARRATION.omen1,
  INN_NARRATION.omen2,
  INN_NARRATION.omen3,
];
